import React, { useContext, useEffect, useState } from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import Column from "@amzn/meridian/column";
import { FormattedMessage } from "react-intl";
import Row from "@amzn/meridian/row";
import { SettingsContext } from "../SettingsContext";
import { PermissionsContext } from "../../../permissions/PermissionsContext";
import { SsdSettingsContext } from "./SsdSettingsContext";
import { logCustomMetric } from "../../../overview/utils/utils";
import ResetTime from "./../ResetTime";
import SsdAdminSettings from "./SsdAdminSettings";
import General from "./General";
import OpsClock from "./OpsClock";
import EventsAndBreaks from "./EventsAndBreaks";
import RoleRequirements from "./RoleRequirements";

const SsdSettingsSkeleton = () => {
  const { dispatch: amzlDispatch } = useContext(SettingsContext);
  const { viewModel, dispatch: ssdDispatch } = useContext(SsdSettingsContext);
  const { isUserAuthorisedForSettingsEdit } = useContext(PermissionsContext);
  const hasAdminSettings =
    viewModel.settingsData.adminSettings &&
    Object.entries(viewModel.settingsData.adminSettings).length > 0;
  const [currentTab, setCurrentTab] = useState("resetTime");

  useEffect(() => {
    let date = new Date().toISOString().substring(0, 10);
    amzlDispatch({
      type: "LOAD_OPS_CLOCK_DATA",
      data: { dispatcher: amzlDispatch, dispatchDate: date },
    });
    amzlDispatch({
      type: "LOAD_BREAKS_DATA",
      data: { dispatcher: amzlDispatch, dispatchDate: date },
    });
    amzlDispatch({ type: "FETCH_CYCLE", data: { dispatcher: amzlDispatch } });
    amzlDispatch({
      type: "FETCH_RESET_TIME",
      data: { dispatcher: amzlDispatch },
    });
    ssdDispatch({
      type: "FETCH_ADMIN_SETTINGS",
      data: { dispatcher: ssdDispatch },
    });
  }, []);

  useEffect(() => {
    setCurrentTab(hasAdminSettings ? "general" : "resetTime");
  }, [hasAdminSettings]);

  return hasAdminSettings ? (
    <Row width="100%">
      <Column spacing="small" spacingInset="medium large none large">
        <TabGroup
          value={currentTab}
          onChange={(a) => {
            setCurrentTab(a);
            logCustomMetric("Tab Switch", a.toString());
          }}
          fill="line"
        >
          <Tab value="general">
            <FormattedMessage id="settings.general" defaultMessage="General" />
          </Tab>
          <Tab value="opsclock">
            <FormattedMessage
              id="settings.opsclock"
              defaultMessage="Ops Clock"
            />
          </Tab>
          <Tab value="eventsAndBreaks">
            <FormattedMessage
              id="settings.eventsAndBreaks"
              defaultMessage="Events & Breaks"
            />
          </Tab>
          <Tab value="indirecthc">
            <FormattedMessage
              id="settings.roleRequirements"
              defaultMessage="Role Requirements"
            />
          </Tab>
          <Tab value="resetTime">
            <FormattedMessage
              id="settings.resetTime"
              defaultMessage="Reset Time"
            />
          </Tab>
          <Tab value="ssdAdminSettings">
            <FormattedMessage
              id="settings.ssdAdminSettings"
              defaultMessage="SSD Admin Settings"
            />
          </Tab>
        </TabGroup>
        {
          {
            general: (
              <General
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            opsclock: (
              <OpsClock
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            eventsAndBreaks: (
              <EventsAndBreaks
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            indirecthc: (
              <RoleRequirements
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            resetTime: (
              <ResetTime
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            ssdAdminSettings: (
              <SsdAdminSettings
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
          }[currentTab]
        }
      </Column>
    </Row>
  ) : (
    <Row width="100%">
      <Column
        width="40%"
        spacing="small"
        spacingInset="medium large none large"
      >
        <TabGroup
          value={currentTab}
          onChange={(a) => {
            setCurrentTab(a);
            logCustomMetric("Tab Switch", a.toString());
          }}
          fill="line"
        >
          <Tab value="resetTime">
            <FormattedMessage
              id="settings.resetTime"
              defaultMessage="Reset Time"
            />
          </Tab>
          <Tab value="ssdAdminSettings">
            <FormattedMessage
              id="settings.ssdAdminSettings"
              defaultMessage="SSD Admin Settings"
            />
          </Tab>
        </TabGroup>
        {
          {
            resetTime: (
              <ResetTime
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
            ssdAdminSettings: (
              <SsdAdminSettings
                props={{
                  isUserAuthorisedForSettingsEdit:
                    isUserAuthorisedForSettingsEdit,
                }}
              />
            ),
          }[currentTab]
        }
      </Column>
    </Row>
  );
};

export default SsdSettingsSkeleton;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdSettingsSkeleton.js